import { Component, Input, OnInit } from '@angular/core';
import { Empty_ProductRequestReview_interface, ProductRequestReview_interface } from 'src/app/Interface/ProductRequestReview_interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { ProductRequestReviewService } from 'src/app/Service/ProductRequest/ProductRequestReview.service';

@Component({
  selector: 'app-ProductRequestReviewForm',
  templateUrl: './ProductRequestReviewForm.component.html',
  styleUrls: ['./ProductRequestReviewForm.component.scss']
})
export class ProductRequestReviewFormComponent implements OnInit {

  @Input() inner_request_id: number = 0
  InProccessing: boolean = false

  DataList_Evaluate: Array<ProductRequestReview_interface> = []
  Data_Seleted_Delete: ProductRequestReview_interface = Empty_ProductRequestReview_interface()

  constructor(
    private ProductRequestReview_Service: ProductRequestReviewService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {

    this.ReadData_Evaluate()
  }

  ReadData_Evaluate() {
    this.InProccessing = true
    this.ProductRequestReview_Service.GetActiveList(this.inner_request_id,
    ).subscribe(
      data => {
        this.DataList_Evaluate = data
        this.InProccessing = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }



  OnSubmit()
  {
    var Indexer: number = -1
    for (let item of this.DataList_Evaluate)
    {
      if (item.dsc == "0")
      {
        Indexer=this.DataList_Evaluate.indexOf(item)
        break;
      }

    }

    if (Indexer > -1) {
      this.Alertify_Service.ErrorMessage("سوال ردیف "+ (Indexer+1) +" را پاسخ دهید")
    }
    else {
      this.InProccessing=true
      this.ProductRequestReview_Service.SubmitEvalute(this.DataList_Evaluate, this.inner_request_id).subscribe(
        data => {
          this.InProccessing=false
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        }

      )
    }

  }


}
